import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { getCourse, getCourses } from '../data/course-data';
import { getLearningOutcomes } from '../data/course-outcomes';
import './course.css';

const Course = () => {
    let { courseSlug } = useParams();
    let course = getCourse(courseSlug);
    let allCourses = getCourses();
    const otherCourses = allCourses
        .filter((item) => item.slug !== courseSlug)
        .slice(0, 5);

    const formatPrice = (item) => `₦${item.price?.toLocaleString?.() ?? item.fee?.replace(/^N/, '')}`;

    if (!course) {
        return (
            <div className="container py-5 text-center">
                <h2>Course not found</h2>
                <p className="mb-4">The course you're looking for doesn't exist or has been removed.</p>
                <Link to="/courses" className="button button-enroll-course btn btn-main-2 rounded">
                    Browse All Courses
                </Link>
            </div>
        );
    }

    const learningOutcomes = getLearningOutcomes(course);
    const curriculumModules = (course.curriculum || []).filter(
        item => !/^internship$/i.test(item.trim())
    );

    return (
        <div>
            <section className="course-page-header">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-xl-8">
                            <div className="title-block">
                                <h1>{course.name}</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="course-header-bubbles">
                    <div className="bubble x1"></div>
                    <div className="bubble x2"></div>
                    <div className="bubble x3"></div>
                    <div className="bubble x4"></div>
                    <div className="bubble x5"></div>
                    <div className="bubble x6"></div>
                    <div className="bubble x7"></div>
                    <div className="bubble x8"></div>
                    <div className="bubble x9"></div>
                    <div className="bubble x10"></div>
                </div>
            </section>

            <section className="page-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 col-xl-8">
                            <nav className="course-single-tabs learn-press-nav-tabs">
                                <div className="nav nav-tabs course-nav" id="nav-tab" role="tablist">
                                    <Link className="nav-item nav-link active" id="nav-home-tab" data-bs-toggle="tab" to="#nav-home" role="tab" aria-controls="nav-home-tab" aria-selected="true">
                                        <span>Course Overview</span>
                                    </Link>
                                </div>
                            </nav>

                            <div className="tab-content tutori-course-content" id="nav-tabContent">
                                <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                                    <div className="single-course-details">
                                        <h4 className="course-title">Description</h4>
                                        <p>{course.description}</p>

                                        <div className="course-widget learning-outcomes-widget">
                                            <div className="learning-outcomes-header">
                                                <div>
                                                    <h4 className="course-title">What You Will Learn</h4>
                                                    <p className="learning-outcomes-subtitle">
                                                        Practical skills you'll gain by the end of this course
                                                    </p>
                                                </div>
                                                <span className="outcomes-badge">
                                                    <i className="fas fa-graduation-cap"></i>
                                                    {learningOutcomes.length} outcomes
                                                </span>
                                            </div>
                                            <div className="learning-outcomes-grid">
                                                {learningOutcomes.map((outcome, index) => (
                                                    <div key={index} className="learning-outcome-card">
                                                        <span className="outcome-number">{index + 1}</span>
                                                        <div className="outcome-content">
                                                            <i className="fas fa-check-circle outcome-icon"></i>
                                                            <p>{outcome}</p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        {curriculumModules.length > 0 && (
                                            <div className="course-widget curriculum-widget">
                                                <h4 className="course-title">Course Curriculum</h4>
                                                <p className="learning-outcomes-subtitle">
                                                    {curriculumModules.length} modules · includes hands-on projects & internship
                                                </p>
                                                <div className="curriculum-modules">
                                                    {curriculumModules.map((module, index) => (
                                                        <div key={index} className="curriculum-module">
                                                            <span className="module-index">{String(index + 1).padStart(2, '0')}</span>
                                                            <span className="module-name">{module}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                        
                                        {course.downloadable && (
                                            <div className="buy-btn">
                                                <a href={course.pdfUrl} download rel="noopener noreferrer">
                                                    <button className="button button-enroll-course btn btn-main-2 rounded">
                                                        <i className="fas fa-download"></i> Download Syllabus
                                                    </button>
                                                </a>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-5 col-xl-4">
                            <div className="course-sidebar course-sidebar-2">
                                <div className="course-widget course-details-info">
                                    <div className="course-thumbnail">
                                        <img src={course.img} alt={course.alt} className="img-fluid w-100" />
                                    </div>
                                    <div className="price-header">
                                        <h2 className="course-price">{course.fee}</h2>
                                    </div>

                                    <ul className="course-sidebar-list">
                                        <li>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span><i className="far fa-sliders-h"></i>Level</span>
                                                Beginner
                                            </div>
                                        </li>
                                        <li>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span><i className="far fa-user"></i>Students</span>
                                                20
                                            </div>
                                        </li>
                                        <li>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span><i className="far fa-clock"></i>Duration</span>
                                                {course.duration}
                                            </div>
                                        </li>
                                        <li>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span><i className="far fa-globe"></i>Language</span>
                                                English
                                            </div>
                                        </li>
                                    </ul>

                                    <div className="buy-btn">
                                        <Link to={`/register?course=${encodeURIComponent(course.name)}`}>
                                            <button id="enrollButton" className="button button-enroll-course btn btn-main-2 rounded">
                                                <i className="far fa-shopping-cart me-2"></i> Enroll Now
                                            </button>
                                        </Link>
                                    </div>
                                </div>

                                <div className="other-courses-widget">
                                    <div className="other-courses-header">
                                        <div>
                                            <h4 className="other-courses-title">Other Courses</h4>
                                            <p className="other-courses-subtitle">Explore more programs at ATH Academy</p>
                                        </div>
                                        <span className="other-courses-badge">{allCourses.length - 1}+</span>
                                    </div>

                                    <ul className="other-courses-list">
                                        {otherCourses.map((item) => (
                                            <li key={item.slug}>
                                                <Link to={`/courses/${item.slug}`} className="other-course-card">
                                                    <div className="other-course-thumb">
                                                        <img src={item.img} alt={item.alt} />
                                                        <span className="other-course-duration">{item.duration}</span>
                                                    </div>
                                                    <div className="other-course-body">
                                                        <h6 className="other-course-name">{item.name}</h6>
                                                        <div className="other-course-meta">
                                                            <span>
                                                                <i className="far fa-play-circle"></i>
                                                                {(item.curriculum || []).length} modules
                                                            </span>
                                                            <span>
                                                                <i className="far fa-signal"></i>
                                                                Beginner
                                                            </span>
                                                        </div>
                                                        <div className="other-course-footer">
                                                            <span className="other-course-price">{formatPrice(item)}</span>
                                                            <span className="other-course-cta">
                                                                View course <i className="fas fa-arrow-right"></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>

                                    <Link to="/courses" className="other-courses-view-all">
                                        Browse all courses <i className="fas fa-th-large ms-2"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Course;